import React, { useEffect, useRef } from "react";

import { Box, CssBaseline, Link, Typography } from "@mui/material";

import { HomeFilled } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Home() {
  const ref = useRef();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  // const instance = idleTimeout(
  //   (element) => {
  //     if (window.location.pathname !== "/") {
  //       navigate("/");
  //     }
  //     // console.log("idle");
  //   },
  //   {
  //     element: document,
  //     loop: true,
  //     timeout: 1000 * 60 * 5,
  //     // timeout: 1000 * 5,
  //   },
  // );

  return (
    <React.Fragment>
      <Box
        ref={ref}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100svh",
          opacity: "1",
          position: "relative",
          width: "100%",
        }}
      >
        <Box sx={{ height: "100%", overflow: "auto" }}>
          <Outlet />
        </Box>

        <Box
          sx={{
            alignItems: "end",
            display: "flex",
            gap: "4px",
            height: "40px",
            justifyContent: "center",
            padding: "6px",
          }}
        >
          <HomeFilled
            onClick={() => navigate("/")}
            sx={{
              "&:hover": { opacity: "1" },
              cursor: "pointer",
              opacity: "0.7",
            }}
          />
          <Copyright />
        </Box>
      </Box>

      <CssBaseline />
      {/* </Box> */}
    </React.Fragment>
  );
}

function Copyright(props) {
  return (
    <Typography
      align="center"
      color="text.secondary"
      variant="body2"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://5systems.ru/" target="_blank">
        5SYSTEMS
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Home;
